import { Anchor, ButtonType } from 'grommet';
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

interface LinkButtonProps extends ButtonType {
  to: string;
}

const StyledLink = styled(Link)`
  display: flex;
  align-items: center;
  justify-content: center;
  text-decoration: none;
` as unknown as any;

export const LinkButton = ({ to, ...props }: LinkButtonProps) => (
  <StyledLink to={to} {...props}>
    <Anchor as="span">{props.children}</Anchor>
  </StyledLink>
);
